import { Sparkles } from "lucide-react";
import { AssistantComposer } from "./assistant-composer";
import { AssistantPresets } from "./assistant-presets";

export function AssistantEmptyState({
  onSend,
  onPreset,
  running,
  initialPrompt,
}: {
  onSend: (message: string) => void;
  onPreset: (preset: {
    id: string;
    name: string;
    text: string;
    autorun?: boolean;
  }) => void;
  running?: boolean;
  initialPrompt?: string;
}) {
  return (
    <div className="flex h-full flex-col items-center justify-center gap-8 px-4 py-10">
      <div className="flex max-w-lg flex-col items-center text-center">
        <div className="mb-4 flex size-12 items-center justify-center rounded-full bg-brand-soft text-brand">
          <Sparkles className="size-6" />
        </div>
        <h1 className="text-xl font-semibold tracking-tight text-foreground">
          I&apos;m your career co-pilot.
        </h1>
        <p className="mt-1 text-sm text-muted-foreground">
          Evaluate roles, research companies, prep interviews, and move your
          pipeline forward.
        </p>
      </div>

      <AssistantComposer
        placeholder="What can I help you do?"
        disabled={running}
        onSend={onSend}
        initialValue={initialPrompt}
      />

      <AssistantPresets onSelect={onPreset} />
    </div>
  );
}
